
export const format_filter = time => f => moment(time || new Date().getTime()).format(f)

// 毫秒转为时分秒展示
export const setDate = (date) => {
  let hours = parseInt(date / 1000 / 60 / 60)
  let mins = parseInt((date - hours * 1000 * 60 * 60) / 1000 / 60)
  if (mins < 10) {
    mins = '0' + mins
  }
  let secs = parseInt((date - hours * 1000 * 60 * 60 - mins * 1000 * 60) / 1000)
  if (secs < 10) {
    secs = '0' + secs
  }

  return `${hours}:${mins}:${secs}`
}

export const delTime = (time) => {
  return time < 10 ? `0${time}` : time
}
